module.exports = __webpack_public_path__ + "assets/media/smsbig.a16e7f18.svg";